/* eslint-disable */
import MobxReactForm from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';
import ProfileAPI from 'services/ProfileAPI';
const interceptor = {
    key: 'default',
    call: ({ change }) => {
        if (change.newValue !== null && change.newValue !== undefined) {
            return change;
        }
        change.newValue = '';
        return change;
    }
};
export const fields = [
    {
        name: 'street',
        label: 'CheckoutPage:contactInformation:fieldLabels.street',
        rules: 'required|string',
        value: '',
        interceptors: [interceptor]
    },
    {
        name: 'number',
        label: 'CheckoutPage:contactInformation:fieldLabels.number',
        rules: 'required|string',
        value: '',
        interceptors: [interceptor]
    },
    {
        name: 'zip',
        label: 'CheckoutPage:contactInformation:fieldLabels.zip',
        type: 'string',
        rules: 'required|postcode',
        value: '',
        interceptors: [interceptor],
        observers: [{
                key: 'value',
                call: ({ form, change: { oldValue, newValue } }) => {
                    const regExp = /^\d{1,5}$/.test(newValue);
                    if (regExp || newValue === '') {
                        form.container().$('zip').set('value', newValue);
                    }
                    else {
                        form.container().$('zip').set('value', oldValue);
                    }
                }
            }]
    },
    {
        name: 'city',
        label: 'CheckoutPage:contactInformation:fieldLabels.city',
        rules: 'required|string',
        value: '',
        interceptors: [interceptor]
    }
];
const hooks = {
    onSuccess: (form) => {
        const { ...values } = form.values();
        const data = {
            deliveryAddress: values,
            hasDeliveryAddress: true
        };
        ProfileAPI.updateUserProfileData(data);
    }
};
const plugins = {
    dvr: dvr({
        package: validatorjs
    })
};
const options = {
    validateOnChange: true
};
export default new MobxReactForm({ fields }, { hooks, plugins, options });
/* eslint-enable */
